import React from "react";
import {
  Col,
  Row,
  Input,
  Label,
  FormFeedback,
} from "reactstrap";
import Select from "react-select";

interface GoalCategoryFormProps {
  validation: any;
  isEdit?: boolean;
}

const TaskForm: React.FC<GoalCategoryFormProps> = ({
  validation,
  isEdit = false,
}) => {
  // Status options (1 for Active, 2 for Inactive)
  const statusOptions = [
    { label: "Active", value: 1 },
    { label: "Inactive", value: 2 },
  ];

  return (
    <Row className="g-3">
      {!isEdit && (
        <Col md={12}>
          <Label className="fw-bold mb-1">
            Task ID <span className="text-danger">*</span>
          </Label>
          <Input
            type="number"
            name="id"
            placeholder="Enter task ID"
            value={validation.values.id || ""}
            onChange={(e) => {
              let value = e.target.value;
              value = value.replace(/[^0-9]/g, "");
              if (value.length > 4) {
                value = value.substring(0, 4);
              }
              validation.setFieldValue("id", value ? Number(value) : "");
            }}
            onBlur={validation.handleBlur}
            max={9999}
            invalid={
              !!(validation.touched.id && validation.errors.id)
            }
          />
          <FormFeedback>{validation.errors.id}</FormFeedback>
        </Col>
      )}

      <Col md={12}>
        <Label className="fw-bold mb-1">
          Task Name <span className="text-danger">*</span>
        </Label>
        <div className="position-relative">
          <Input
            type="text"
            name="taskname"
            placeholder="Enter task name"
            value={validation.values.taskname || ""}
            onChange={(e) => {
              let text = e.target.value;
              if (text.length > 70) {
                text = text.substring(0, 70);
              }
              validation.setFieldValue("taskname", text);
            }}
            onBlur={validation.handleBlur}
            style={{ paddingRight: "50px" }}
            invalid={
              !!(validation.touched.taskname && validation.errors.taskname)
            }
          />
          <FormFeedback>{validation.errors.taskname}</FormFeedback>
          <div
            style={{
              position: "absolute",
              top: "50%",
              right: "12px",
              transform: "translateY(-50%)",
              fontSize: "12px",
              color: "#6c757d",
              pointerEvents: "none",
            }}
          >
            {(validation.values.taskname || "").length}/70
          </div>
        </div>
      </Col>

      <Col md={12}>
        <Label className="fw-bold mb-1">
          Description <span className="text-danger">*</span>
        </Label>
        <div className="position-relative">
          <Input
            type="text"
            name="description"
            placeholder="Enter description"
            value={validation.values.description || ""}
            onChange={(e) => {
              let text = e.target.value;
              if (text.length > 100) {
                text = text.substring(0, 100);
              }
              validation.setFieldValue("description", text);
            }}
            onBlur={validation.handleBlur}
            style={{ paddingRight: "60px" }}
            invalid={
              !!(validation.touched.description && validation.errors.description)
            }
          />
          <FormFeedback>{validation.errors.description}</FormFeedback>
          <div
            style={{
              position: "absolute",
              top: "50%",
              right: "12px",
              transform: "translateY(-50%)",
              fontSize: "12px",
              color: "#6c757d",
              pointerEvents: "none",
            }}
          >
            {(validation.values.description || "").length}/100
          </div>
        </div>
      </Col>

      {isEdit && (
        <Col md={12}>
          <Label className="fw-bold mb-1">
            Status <span className="text-danger">*</span>
          </Label>
          <div style={{ width: "200px" }}>
            <Select
              options={statusOptions}
              name="status"
              placeholder="Select status"
              value={statusOptions.find((opt) => opt.value === Number(validation.values.status)) || null}
              onChange={(e: { value: any }) => validation.setFieldValue("status", e?.value)}
              onBlur={() => validation.setFieldTouched("status", true)}
              classNamePrefix="react-select"
              className={validation.touched.status && validation.errors.status ? "react-select-error" : ""}
            />
          </div>
          {validation.touched.status && validation.errors.status && (
            <div className="invalid-feedback d-block">{validation.errors.status}</div>
          )}
        </Col>
      )}
    </Row>
  );
};

export default TaskForm;
